module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1089.e2080386.png";